module.exports = __webpack_public_path__ + "static/img/background.ce92e839.png";